module.exports = __webpack_public_path__ + "img/hydt_3.62df5bf4.png";